import axios from "axios";
import dayjs from "dayjs";
import OperationTypes from "../../../types";

export enum EnumStatusReasons {
  AVAILABLE="AVAILABLE",
  NOT_AVAILABLE="NOT_AVAILABLE",
}

export enum EnumReasonCodeState {
  OPEN="OPEN",
  POTENTIAL="POTENTIAL",
  CLOSED="CLOSED",
}

export interface IUnavailabilityReasonRequest {
  id: number | null;
  reasonCodeState?: string;
  statusReasonCode: string;
  reservedStatusCode?: boolean;
  restrictedStatusCode?: boolean;
  manuallyRemovable?: boolean;
  expectedStartUnavailabilityDatetime: string;
  actualStartUnavailabilityDatetime: string | null;
  expectedEndUnavailabilityDatetime?: string | null;
  actualEndUnavailabilityDatetime?: string | null;
  notes?: string;
};

const VehicleAvailabilityService = {
  get: {
    vehicleByPlate: (tenant:string,plate: string) => {
      return axios.get<OperationTypes.Vehicle>(`masterdatavehicle/vehicle/plate/${plate}`,{params:{tenant:tenant}}).then(
        response => response.data,
      )
    },
    availabilityStatusReasons: (tenant:string,statusReason: EnumStatusReasons, includeSpecialCodes: boolean, vehiclePlate: string) => {
      return axios.get<OperationTypes.Domain[]>("masterdatavehicle/statusreason/all", {
        params: {
          tenant:tenant,
          valid: true,
          status: statusReason,
          includeSpecialCodes,
          vehiclePlate: vehiclePlate
        }
      }).then(
        response => response.data,
      )
    },
    availabilityStatusReasonsIncludingInvalid: (tenant:string,statusReason:EnumStatusReasons,includeSpecialCodes:boolean,vehiclePlate:string) => {
      return axios.get<OperationTypes.Domain[]>("masterdatavehicle/statusreason/all", {
        params: {
          tenant:tenant,
          status:statusReason,
          includeSpecialCodes,
          vehiclePlate:vehiclePlate
        }
      }).then(
        response => response.data,
        )
    },
    unavailabilityByVehicle: (tenant:string,id: number) => {
      return axios.get<OperationTypes.VehicleAvailability.Status>(`masterdatavehicle/unavailability/unavailabilityByVehicle/${id}`,{params:{tenant:tenant}})
        .then(
          response => response.data,
        );
    }
  },
  update: {
    unavailabilityReasons: (tenant:string,vehicleId: number, unavailabilityReasonRequests : IUnavailabilityReasonRequest[]) => {
      unavailabilityReasonRequests.forEach(element => {
        if (dayjs(element.actualStartUnavailabilityDatetime).isAfter(dayjs())) {
          element.actualStartUnavailabilityDatetime = null;
        }
      });
      
      const req = {vehicleId, unavailabilityReasonRequests};

      return axios.post("masterdatavehicle/unavailability/setUnavailabilityReasons", req, {params:{tenant:tenant}}).then(
        response => response.data,
      )
    },
    changeAvailabilityReason: (tenant:string,vehicleId: number, availabilityCode: string) => {
      const data = { vehicleId, availabilityCode };
      return axios.post<OperationTypes.VehicleAvailability.Status>("masterdatavehicle/unavailability/changeAvailabilityReason", data,{params:{tenant:tenant}}).then(
        response => response.data
      )
    }
  }
}

export default VehicleAvailabilityService;